<div class="inv-dialog">
  <h2 mat-dialog-title class="text-xl font-semibold mb-1">Invited bidders</h2>
  <p class="text-sm text-gray-600 mb-4">{{ data.boq_code }}<span *ngIf="data.boq_name"> — {{ data.boq_name }}</span></p>

  <div *ngIf="loading" class="py-8 text-center">
    <mat-spinner diameter="40" class="mx-auto"></mat-spinner>
    <p class="mt-4 text-gray-600">Loading invited bidders...</p>
  </div>

  <div *ngIf="!loading && invitations.length === 0" class="py-8 text-center text-gray-500">
    <mat-icon class="text-5xl mb-2">inbox</mat-icon>
    <p>No bidding invitations sent for this BOQ</p>
    <p class="text-sm mt-1">Use “Send for Bidding” to invite consultancy organizations or emails</p>
  </div>

  <div *ngIf="!loading && invitations.length" class="space-y-4">
    <div *ngFor="let inv of invitations" class="inv-card">
      <div class="inv-card-head">
        <div>
          <p class="font-medium">{{ inv.boq_code }} — {{ inv.boq_name }}</p>
          <p class="text-sm text-gray-500">{{ inv.bid_count || 0 }} bid(s) received</p>
          <p class="text-xs mt-1" *ngIf="inv.status === 'draft'">
            <span class="px-2 py-0.5 rounded-full bg-gray-100 text-gray-700">Draft RFQ</span>
            Invite vendors to publish.
          </p>
          <p class="text-xs mt-1" *ngIf="inv.status === 'active'">
            <span class="px-2 py-0.5 rounded-full bg-green-100 text-green-800">Published</span>
          </p>
          <p class="text-xs mt-1" *ngIf="inv.status === 'closed'">
            <span class="px-2 py-0.5 rounded-full bg-red-100 text-red-800">Closed</span>
          </p>
          <div *ngIf="inv.stats_summary" class="mt-2 flex gap-4 text-xs">
            <span><strong>{{ inv.stats_summary.total_invited }}</strong> invited</span>
            <span class="text-green-600"><strong>{{ inv.stats_summary.completed }}</strong> submitted</span>
            <span class="text-amber-600"><strong>{{ inv.stats_summary.pending }}</strong> pending</span>
          </div>
          <p *ngIf="inv.expires_at" class="text-xs text-gray-500 mt-1">Bids close: {{ inv.expires_at | date: 'medium' }}</p>
        </div>
        <button type="button" mat-raised-button color="primary" (click)="viewBids(inv)" *ngIf="inv.status !== 'draft'">
          <mat-icon class="mr-1">visibility</mat-icon>
          View Bids
        </button>
      </div>

      <div class="inv-table-wrap" *ngIf="inv.invited_details?.length">
        <table class="inv-table">
          <thead>
            <tr>
              <th>Invited to</th>
              <th>Type</th>
              <th>Status</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let person of inv.invited_details">
              <td>
                <span class="inv-name">{{ person.name }}</span>
                <span *ngIf="person.email" class="inv-email">({{ person.email }})</span>
              </td>
              <td>
                <span *ngIf="person.type === 'org'" class="badge badge-org">Organization</span>
                <span *ngIf="person.type === 'guest'" class="badge badge-guest">Guest (Email)</span>
              </td>
              <td>
                <span *ngIf="person.completed" class="badge badge-done">Submitted</span>
                <span *ngIf="!person.completed" class="badge badge-wait">Pending</span>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
      <p class="text-xs text-gray-500 mt-2" *ngIf="!inv.invited_details?.length">No invitees recorded on this invitation.</p>
    </div>

    <section class="invite-more" *ngIf="activeInvitation" id="invite-more-section">
      <div class="invite-more-head">
        <h3>Invite more bidders</h3>
        <span class="invite-count" *ngIf="inviteCount">{{ inviteCount }} selected</span>
      </div>
      <p class="invite-hint">Adds recipients to the existing bidding link and emails them. Already invited people are listed above.</p>
      <form [formGroup]="inviteForm" (ngSubmit)="submitMoreInvitees()" class="invite-more-form">
        <div class="invite-grid">
          <label class="invite-field">
            <span class="invite-label">Registered consultancies</span>
            <ng-select
              formControlName="invited_org_ids"
              [items]="availableOrgs"
              bindLabel="org_name"
              bindValue="org_id"
              placeholder="Search organizations"
              [multiple]="true"
              [loading]="orgsLoading"
              [searchable]="true"
              [closeOnSelect]="false"
              appendTo="body">
            </ng-select>
          </label>
          <label class="invite-field">
            <span class="invite-label">Or email (not registered)</span>
            <ng-select
              formControlName="invited_emails"
              [items]="[]"
              [addTag]="true"
              [addTagText]="'Add email'"
              placeholder="Type email, press Enter"
              [multiple]="true"
              [searchable]="true"
              [closeOnSelect]="false"
              appendTo="body">
            </ng-select>
          </label>
        </div>
        <div class="invite-actions">
          <button mat-raised-button color="primary" type="submit" [disabled]="submitting || inviteCount === 0">
            {{ submitting ? 'Sending…' : (inviteCount ? 'Invite ' + inviteCount + ' more' : 'Invite more') }}
          </button>
        </div>
      </form>
    </section>

    <p class="text-xs text-gray-500" *ngIf="invitations.length && !activeInvitation">
      Bidding is closed or expired, so additional bidders cannot be invited.
    </p>
  </div>

  <div mat-dialog-actions class="flex justify-end pt-4">
    <button type="button" mat-raised-button (click)="onClose()">Close</button>
  </div>
</div>
